export default __webpack_public_path__ + "static/media/dripicons-v2.f19dcc03.woff";